import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import React from 'react';
import { Box } from '@houzz/ui/';
import Icon from './icon';
import Navigation from './navigation';
import './header.css';

const Header = ({ siteTitle = 'Houzz UI Design System', bg = 'bg.primary' }) => {
    return (
        <Box as="header" bg={bg}>
            <Helmet>
                <title>{siteTitle}</title>
            </Helmet>
            <div className="header">
                <h1 className="header-logo" style={{ margin: 0, position: 'relative' }}>
                    <Link to="/">
                        <div style={{ width: '114px' }}>
                            <Icon fill="white" />
                        </div>
                        <span style={{ display: 'none' }}>{siteTitle}</span>
                    </Link>
                </h1>
                <Navigation mode="dark" />
            </div>
        </Box>
    );
};

Header.propTypes = {
    siteTitle: PropTypes.string,
    bg: PropTypes.string,
};

Header.defaultProps = {
    siteTitle: '',
};

export default Header;
